
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M12.038.02c-6.617 0-12 5.382-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10zm4.765-14.105l-3.457 4.105 3.457 4.105a1 1 0 11-1.53 1.289l-3.235-3.842-3.235 3.842a.998.998 0 01-1.41.12.999.999 0 01-.12-1.409l3.457-4.105-3.457-4.105a1 1 0 011.529-1.289l3.235 3.842 3.235-3.842a1 1 0 111.529 1.289z"}})])
          )
        }
      }
    